import Vue from 'vue'
import Vant from 'vant'
import 'amfe-flexible'
import 'vant/lib/index.css'
import * as dd from 'dingtalk-jsapi'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import $http from './utils/request'
import './utils/dataFormat'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { Dialog, Notify, Toast } from 'vant'
import '@/assets/font/font.css'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import { ImagePreview } from 'vant';
// 全局注册
Vue.use(ImagePreview);

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 只在开发环境引入 VConsole
if(process.env.NODE_ENV === 'development') {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole()
  })
}

import ContentBox from '@/components/Basic/ContentBox'
import Navbar from '@/components/Basic/Navbar'
import Pagination from '@/components/Pagination'
import DatetimePicker from '@/components/DatetimePicker'
import FieldLayout from '@/components/FieldLayout'
import FloatBtn from '@/components/FloatBtn'
import ImageUpload from '@/components/ImageUpload'
import FileUpload from '@/components/FileUpload'
import DictSelect from '@/components/DictSelect'
import ItemsSelect from '@/components/ItemsSelect'
import Search from '@/components/Search'
import Customer from '@/components/Customer'
import Address from '@/components/Address'
import VxeTableGrid from '@/components/VxeTableGrid'

Vue.component('ContentBox', ContentBox)
Vue.component('Navbar', Navbar)
Vue.component('Pagination', Pagination)
Vue.component('DatetimePicker', DatetimePicker)
Vue.component('FieldLayout', FieldLayout)
Vue.component('FloatBtn', FloatBtn)
Vue.component('ImageUpload', ImageUpload)
Vue.component('FileUpload', FileUpload)
Vue.component('DictSelect', DictSelect)
Vue.component('ItemsSelect', ItemsSelect)
Vue.component('Search', Search)
Vue.component('Customer', Customer)
Vue.component('Address', Address)
Vue.component('VxeTableGrid', VxeTableGrid)


// Vue.config.productionTip = false 
Vue.prototype.$http = $http
Vue.prototype.notInDingTalk = dd.env.platform === 'notInDingTalk'
Vue.prototype.regexp = {
  phone: /1\d{10}/,
  intNum: /^[1-9]\d*$/,
}
Vue.prototype.$minDate = new Date()
Vue.prototype.$maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
Vue.prototype.$modal = VXETable.modal
Vue.prototype.$dialog = Dialog
Vue.prototype.$notify = Notify
Vue.prototype.$toast = Toast
Vue.prototype.$imagePreview = ImagePreview
Vue.prototype.$them = {
  color: '#1989fa',
  bgcolor: '#1989fa',
  bg: '#1989fa',
}

// 请求成功和失败的提示回调
Vue.prototype.$callbackMsg = (code, message) => {
  if(Number(code)  === 200) {
    Notify({type: 'success', message})
  } else {
    Notify({type: 'warning', message})
  }
}

// 弹窗询问
Vue.prototype.$confirmTips = (msg, confirmFun, cancelFun) => {
  Dialog.confirm({
    title: '提示',
    message: msg
  }).then(() => {
    confirmFun && confirmFun()
  }).catch(() => {
    cancelFun && cancelFun()
  })
}

// 对象、数组深拷贝（deepCopy）
Vue.prototype.$dc = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

//按钮防抖事件：当第一次点击按钮时，设置它的 disabled 属性，超过防抖时间后释放属性
Vue.directive('debounce', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 2000)//我这里设置的是2000毫秒也就是2秒
    })
  }
})

Vue.use(Vant)
Vue.use(VXETable)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
